import React, { useState, useEffect } from 'react';
import  { useNavigate } from 'react-router-dom'

import HeaderComponent from '../components/Header.js'
import FooterComponent from '../components/Footer'

import imgBannerMobile from '../images/main/mobile/img_banner.png'
import imgBannerTablet from '../images/main/desktop/img_banner.png'

import imgDogCatMobile from '../images/main/mobile/img_dogcat.png'
import imgDogCatTablet from '../images/main/desktop/img_dogcat.png'

import iconCorrect from '../images/main/ic_correct.svg'
import iconInCorrect from '../images/main/ic_incorrect.svg'
import imgCorrectPic1 from '../images/main/img_correct_pic1.png'
import imgCorrectPic2 from '../images/main/img_correct_pic2.png'
import imgCorrectPic3 from '../images/main/img_correct_pic3.png'
import imgInCorrectPic1 from '../images/main/img_incorrect_pic1.png'
import imgInCorrectPic2 from '../images/main/img_incorrect_pic2.png'
import imgInCorrectPic3 from '../images/main/img_incorrect_pic3.png'

import iconAlertError from '../images/main/ic_alert_error.svg'


import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { css } from '@emotion/react';
// First way to import
import { BeatLoader, ClipLoader } from 'react-spinners';

function MainPage() {

  const navigate = useNavigate();
  const MySwal = withReactContent(Swal)

  const [ policyNumber, setPolicyNumber ] = useState("")
  const [ plateNumber, setPlateNumber ] = useState("")
  const [ errorPolicyNumber, setErrorPolicyNumber ] = useState(false)
  const [ isSubmit, setIsSubmit ] = useState(true)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])





  function gotoForm( plateNumber, previousPolicy ){
    navigate(
        "/form",
        {
          state : {
            policy_number : policyNumber,
            plate_number: plateNumber,
            previous_policy: previousPolicy
          }
        }

    )
  }
  function gotoConfirm(){
    navigate(
        "/confirm",
        {
          state : {
            policy_number : policyNumber
          }
        }

    )
  }
  function submit(){
    setIsSubmit(false)
    if(policyNumber.length > 0 && policyNumber.length === 16){
      callCheckPolicyApi()
    }
    else if(policyNumber.length >= 0){
      setErrorPolicyNumber(true)
      setIsSubmit(true)
    }
    else{
      setErrorPolicyNumber(true)
      setIsSubmit(true)
    }
  }

  function validateFormNumberOnly(event){
    if (!/[0-9]/.test(event.nativeEvent.data) && (event.nativeEvent.data !== null ) && event.nativeEvent.data !== undefined) {
      event.preventDefault();
    }
    else if( event.nativeEvent.data === undefined){
      setPolicyNumber("")
    }
    else{
      setErrorPolicyNumber(false)
      setPolicyNumber(event.target.value)
    }
  }

  function showError( message ){

    Swal.fire({
      title: 'ขออภัย',
      html: '<div class="swal-content">'+message+'</div>',
      icon: 'error', 
      allowOutsideClick: false,
      iconHtml: `<img src="${iconAlertError}">`,
      showCancelButton: false,
      confirmButtonText: '<span class="">ตกลง</span>',
      confirmButtonColor: '#009640',
      customClass: {
        icon: 'swal-icon',
        title: 'swal-title',
        content : 'swal-content',
        popup:  'swal-content swal-contrainner',
        actions: 'swal-action',
        confirmButton: 'swal-confirm'
        
      }

    }).then((result) => {
      if (result.isConfirmed) {
        setPolicyNumber("")
      }
    })
  }


  function callCheckPolicyApi(  ){
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(
        { 
          policy_no: policyNumber
        }
      )
    };
  
    fetch('https://petregister.innovation.thaivivat.co.th/api/v1/service/api/checkPolicy.php', requestOptions)
    .then(response => response.json())
    .then(data => validateCheckPolicyApi(data), (error) => {
      if (error) {
        // handle error here
        setIsSubmit(true)
      }
    });
    
  } 

  function validateCheckPolicyApi( data ){
    setIsSubmit(true)
    if(data.data !== undefined ){
      if(data.data.is_success === true){
        gotoConfirm()
      }
      else{
        if(data.data.verify !== null){
          if(data.data.verify.is_success === true){
            const plateNumber = data.data.plate_number
            const previousPolicy = data.data.previous_policy
            setPolicyNumber( plateNumber )
            gotoForm(plateNumber, previousPolicy)
          }
          else{
            showError(data.data.verify.message_error)
          }
          
        }
        else{
          showError("ไม่พบข้อมูลหมายเลขกรรมธรม์<br/>กรุณาลองใหม่อีกครั้ง")
        }
      }
    }
    else{
      showError("ไม่พบข้อมูลหมายเลขกรรมธรม์<br/>กรุณาลองใหม่อีกครั้ง")
    }
  }
  
  return (
  <div className="w-fullbg-white font-prompt ">


      <div className="w-full flex flex-wrap bg-white font-prompt">

        <HeaderComponent></HeaderComponent>
        <div className='flex flex-wrap w-full  '>
      
        <div className='flex flex-wrap w-full  bg-cover lg:bg-main-banner '>
            <div className='w-full flex flex-wrap lg:w-1092 lg:mx-auto'>
              {/* Mobile + Tablet  */}
              <div className='flex md:hidden w-full justify-center bg-main-banner'>
                <img src={imgBannerMobile} alt="banner_pet"/>
              </div>

              <div className='hidden md:flex lg:hidden w-full justify-center  bg-main-banner'>
                <img src={imgBannerTablet} alt="banner_pet"/>
              </div>

              <div className='w-full lg:w-1/2 text-black pl-4 md:pl-12 lg:pl-0 pr-4 md:pr-12 my-6 flex justify-center mb-8 '>
                <div className='w-full md:w-11/12 lg:w-full justify-center pr-0 mt-0 lg:mt-12'>
                  <label className='flex text-2xl md:text-3xl lg:text-3-5xl lg:leading-11 w-full font-semibold'>รับทันทีความคุ้มครองสัตว์เลี้ยง</label>
                  <label className='flex text-md md:text-xl w-full mt-2 lg:mt-1 lg:font-normal lg:text-2xl lg:leading-8'>สำหรับลูกค้าประกันรถเปิดปิด*​<br/>เพียงกรอกเลขกรมธรรม์ประกันรถยนต์</label>

                  <input value={policyNumber} onChange={(event) => { validateFormNumberOnly(event) } }  type={'search'} className={'w-full h-14 mt-6 md:mt-8 lg:mt-6 mb-0  border py-2 px-4 rounded-md font-sarabun focus:outline-none focus:border-green-500 focus:border-2 border-radius-other '+ ( (errorPolicyNumber)? ' border-red-500 ' : ' border-grey-300 ' )} placeholder='กรุณาระบุหมายเลขกรมธรรม์ 16 หลัก' />
      
                  {
                    (errorPolicyNumber)?
                      <label className={'flex w-full text-red-500 text-xs' }>กรุณาระบุเลขกรมธรรม์ให้ถูกต้อง </label>
                    :
                    null
                  }
                  <button 
                  disabled={ (isSubmit === false)? "disabled" : ""} 
                  onClick={submit} 
                  className={' w-full lg:w-auto lg:px-4 text-base leading-6 h-[48px]  mt-6 md:h-12 font-medium rounded-md border-radius-other  '+ ( (isSubmit === false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                    กดรับสิทธิ์
                  </button>

                  <div className='w-full my-6'> 
                    <span className='text-grey-600 font-normal leading-4 text-xs'>* ลูกค้าประกันรถเปิดปิดไทยวิวัฒน์ แบบ Package 4 เดือนขึ้นไป หรือ ประกันรถเปิดปิดไทยวิวัฒน์ แบบ Top-up ทุกแผน ที่กรมธรรม์มีผลคุ้มครอง ตั้งแต่วันนี้ - 31 ธ.ค. 68 เงื่อนไขความคุ้มครองเป็นไปตามกรมธรรม์ประกันภัย โปรดศึกษา รายละเอียดก่อนตัดสินใจทำประกันภัยทุกครั้ง</span>
                  </div>
                  
                </div>
              </div>
            
              {/* Desktop  */}
              <div className='hidden lg:flex w-1/2 justify-end '>
                <img src={imgBannerTablet}  alt="banner_pet"/>
              </div>
            </div>
        </div>

        <div className='flex flex-wrap w-full   pl-4 md:pl-12 pr-4 md:pr-12 my-18 justify-center'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>
            <label className='flex text-3-5xl lg:text-4-5xl leading-11 lg:leading-14 w-full font-medium text-center justify-center'>ความคุ้มครองสัตว์เลี้ยงไทยวิวัฒน์</label>
            <label className='flex md:hidden text-lg md:text-2xl w-full mt-6 text-grey-600 text-center justify-center'>ขับรถแล้วเกิดอุบัติเหตุก็อุ่นใจ<br/> หมดห่วงเรื่องค่ารักษา<br/> คุ้มครองถึงการเสียชีวิตและบาดเจ็บ<br/> ของน้องๆ 4 ขาในรถ ด้วยความคุ้มครอง<br/>สัตว์เลี้ยงสำหรับสุนัขและแมว<br/> วงเงินความคุ้มครองรวมกัน<br/>สูงสุดถึง 10,000 บาท</label>
            <label className='hidden md:flex lg:hidden text-xl lg:text-2xl leading-7 lg:leading-8  w-full mt-6 md:mt-8 text-grey-600 font-normal text-center justify-center'>ขับรถแล้วเกิดอุบัติเหตุก็อุ่นใจ หมดห่วงเรื่องค่ารักษา<br/> คุ้มครองถึงการเสียชีวิตและบาดเจ็บ ของน้องๆ 4 ขาในรถ<br/> ด้วยความคุ้มครองสัตว์เลี้ยงสำหรับสุนัขและแมว<br/> วงเงินความคุ้มครองรวมกันสูงสุดถึง 10,000 บาท</label> 
            <label className='hidden lg:flex text-xl lg:text-2xl leading-7 lg:leading-8  w-full mt-6 md:mt-8 text-grey-600 font-normal text-center justify-center'>ขับรถแล้วเกิดอุบัติเหตุก็อุ่นใจ หมดห่วงเรื่องค่ารักษา คุ้มครองถึงการเสียชีวิตและบาดเจ็บ ของน้องๆ 4 ขาในรถ ด้วยความคุ้มครองสัตว์เลี้ยงสำหรับสุนัขและแมว วงเงินความคุ้มครองรวมกันสูงสุดถึง 10,000 บาท</label>
         
          </div>
        </div>

      
        <div className='flex flex-wrap w-full'>
          <div className='flex flex-wrap w-full lg:max-w-1440 lg:mx-auto'>
          </div>
          <div className='flex md:hidden w-full justify-center mt-6'>
            <img src={imgDogCatMobile} className='w-full'  alt="banner_dogcat"/>
          </div>
          <div className='hidden md:flex w-full justify-center mt-6'>
            <img src={imgDogCatTablet} className='md:w-1440'  alt="banner_dogcat" />
          </div>
        </div>


        <div className='flex flex-wrap w-full bg-grey-200 pt-18'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>
            <div className='flex flex-wrap w-full  pl-4 md:pl-12 pr-4 md:pr-12justify-center'>
              <label className='flex md:hidden text-3-5xl leading-11 w-full font-medium  text-center justify-center'>ลงทะเบียนง่าย<br/>ผ่านช่องทางออนไลน์</label>
              <label className='hidden md:flex text-3-5xl leading-11 w-full font-medium  text-center justify-center'>ลงทะเบียนง่าย ผ่านช่องทางออนไลน์</label>

              <label className='flex md:hidden leading-6 text-lg md:text-2xl w-full mt-2 text-grey-600 text-center justify-center'>ลงทะเบียนคุ้มครองสัตว์เลี้ยงได้ <br/>2 ตัว ต่อการซื้อ 1 กรมธรรม์</label>
              <label className='hidden md:flex text-lg md:text-2xl lg:text-2xl lg:leading-8 lg:font-normal w-full mt-4 text-grey-600 text-center justify-center'>ลงทะเบียนคุ้มครองสัตว์เลี้ยงได้ 2 ตัว ต่อการซื้อ 1 กรมธรรม์</label>
            
              <div className='border-t-2 border-green-500 lg:rounded-sm w-48 md:w-96 mt-8 mx-auto'></div>

              <label className='flex md:hidden text-lg md:text-xl w-full my-8 text-black text-center justify-center'>กรุณาเตรียมรูปถ่ายสัตว์เลี้ยง <br/>2 รูป เพื่อใช้ในการสมัคร <br/>1. รูปหน้าตรง 1 รูป 2. รูปถ่ายเต็มตัว 1 รูป</label>
              <label className='hidden md:flex text-xl font-medium leading-7 w-full my-8 text-black text-center justify-center'>กรุณาเตรียมรูปถ่ายสัตว์เลี้ยง 2 รูป เพื่อใช้ในการสมัคร <br/>1. รูปหน้าตรง 1 รูป 2. รูปถ่ายเต็มตัว 1 รูป</label>
            </div>
          </div>
        </div>


        <div className='flex flex-wrap w-full bg-grey-200 pb-18'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>  

            <div className='flex flex-wrap w-full lg:w-1/2 pl-4 md:pl-12 pr-4 md:pr-12 lg:px-12 mt-6 md:mt-6 mb-6 justify-center'>
              <div className='relative w-full md:w-534 '>

                <div className='w-full absolute  justify-center'>
                  <div className='flex  w-full z-20 justify-center'>
                    <div className='flex align-middle text-md md:text-xl font-bold bg-green-200 py-2 px-4 -mt-2 rounded-full'>คำแนะนำรูปภาพที่ถูกต้อง</div>
                  </div>
                </div>
                <div className=' pt-12 pb-8 w-full  px-6 bg-white border-2 border-green-500 rounded-md z-10 mt-3'>
                  <div className='w-full flex justify-center'>
                    <img className='w-20 h-20 md:w-120 md:h-120' src={imgCorrectPic1}   alt="icon_correct" />
                    <img className='w-20 h-20 md:w-120 md:h-120 ml-2' src={imgCorrectPic2}   alt="icon_correct" />
                    <img className='w-20 h-20 md:w-120 md:h-120 ml-2' src={imgCorrectPic3}   alt="icon_correct" />
                  </div>
                  <div className='w-full flex mt-4 flex-wrap'>
                    <div  className='flex w-full'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}  alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ภาพหน้าตรง</label>
                    </div>

                    
                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ภาพเต็มตัว</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ภาพสี</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ไม่สวมเครื่องแต่งกายหรืออุปกรณ์ใดๆ</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>เป็นภาพไม่เกิน 3 เดือน</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconCorrect}   alt="icon_correct" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ไม่ถ่ายรวมกับสัตว์เลี้ยงตัวอื่น</label>
                    </div>

                  </div>
                </div>
              </div>




            </div>

            <div className='flex flex-wrap w-full  lg:w-1/2   pl-4 md:pl-12 lg:px-12 pr-4 md:pr-12 mt-6 md:mt-6 mb-6 justify-center'>
              <div className='relative w-full  md:w-534  '>

                <div className='w-full absolute  justify-center'>
                  <div className='flex  w-full z-20 justify-center'>
                    <div className='flex align-middle text-md md:text-xl font-bold bg-red-200 py-2 px-4 -mt-2 rounded-full'>คำแนะนำรูปภาพที่ไม่ควรใช้</div>
                  </div>
                </div>
                <div className=' pt-12 pb-8 lg:pb-24 w-full px-6 bg-white border-2 border-red-500 rounded-md z-10 mt-3'>
                  <div className='w-full flex justify-center'>
                    <img className='w-20 h-20 md:w-120 md:h-120 lg:w-120 lg:h-120 ' src={imgInCorrectPic1} alt="icon_incorrect" />
                    <img className='w-20 h-20 md:w-120 md:h-120 lg:w-120 lg:h-120 ml-4' src={imgInCorrectPic2} alt="icon_incorrect" />
                    <img className='w-20 h-20 md:w-120 md:h-120 lg:w-120 lg:h-120 ml-4' src={imgInCorrectPic3} alt="icon_incorrect" />
                  </div>
                  <div className='w-full flex mt-4 flex-wrap'>
                    <div  className='flex w-full'>
                      <div className='flex'>
                        <img className='my-auto' src={iconInCorrect} alt="icon_incorrect" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>เห็นสัตว์เลี้ยงเล็กเกินไป</label>
                    </div>

                    
                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconInCorrect} alt="icon_incorrect" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ใส่เสื้อผ้าเครื่องประดับ</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconInCorrect} alt="icon_incorrect" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>มีสัตว์เลี้ยงหลายตัวในภาพเดียวกัน</label>
                    </div>

                    <div  className='flex w-full mt-1'>
                      <div className='flex'>
                        <img className='my-auto' src={iconInCorrect} alt="icon_incorrect" />
                      </div>
                      <label className='flex my-auto ml-2 text-md md:text-lg'>ไม่เห็นหน้าสัตว์เลี้ยง</label>
                    </div>

                  </div>
                </div>
              </div>



            </div>

          </div>
        </div>

        <div className='flex flex-wrap w-full bg-white'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'>  

            <div className='w-full  pl-4 md:pl-12 pr-4 md:pr-12 my-18 flex '>
              <div className='w-full'>
                <label className='flex text-xl md:text-2xl w-full leading-7 md:leading-8 font-medium text-center '>เงื่อนไขความคุ้มครองการประกันภัย</label>
                <ol className='list-disc font-sarabun text-grey-600 px-4 text-md md:text-base md:font-normal md:leading-6'>
                  <li className='mt-4'>คุ้มครองสัตว์เลี้ยงอันเนื่องมาจากบาดเจ็บและ/หรือเสียชีวิตจากการโดยสารในรถยนต์คันที่ทำประกันภัยรถเปิดปิดซึ่งเกิดอุบัติเหตุชนกับยาพาหนะทางบกโดยมีความคุ้มครองตามจำนวนเงินผลประโยชน์สูงสุดรวมกันทุกความคุ้มครองและสัตว์เลี้ยงทั้งหมดที่ลงทะเบียนไม่เกิน 10,000 บาทสำหรับทุกอุบัติเหตุรวมกันตลอดระยะเวลาเริ่มต้นและสิ้นสุดความคุ้มครอง (ระยะเวลาคุ้มครองสัตว์เลี้ยง เริ่มต้นและสิ้นสุดในวันและเวลาเดียวกับกรมธรรม์ประกันรถเปิดปิดที่ได้รับสิทธิพิเศษ)</li>
                  <li className='mt-3'>ความคุ้มครองนี้จะมีผลบังคับใช้เมื่อการลงทะเบียนที่ถูกต้องสมบูรณ์ได้รับการพิจารณาอนุมัติจากบริษัทฯ เรียบร้อยแล้วเท่านั้น</li>
                  <li className='mt-3'>สัตว์เลี้ยงที่นำมาลงทะเบียนต้องเป็นสุนัข
    หรือแมวที่ถูกเลี้ยงหรือดูแลโดยมีวัตถุประสงค์
    เพื่อให้เป็นสัตว์เลี้ยงหรือสัตว์ที่เลี้ยงไว้เป็นเพื่อน โดยไม่ใช่การเลี้ยงที่มีวัตถุประสงค์เพื่อการ
    ซื้อขาย การเลี้ยงไว้เพื่อเป็นพ่อพันธุ์ แม่พันธุ์ หรือวัตถุประสงค์อื่นเช่น ต่อสู้ ล่าสัตว์ แข่งขัน ค้นหาและกู้ภัย หรือสุนัขตำรวจ เป็นต้น</li>
                  <li className='mt-3'>
                    อายุของสัตว์เลี้ยงที่นำมาลงทะเบียนและได้รับความคุ้มครอง
                    <ol className='list-circle pl-4'>
                      <li> สุนัขมีอายุตั้งแต่ 8 สัปดาห์ และไม่เกิน 9 ปี</li>
                      <li> แมวมีอายุตั้งแต่ 8 สัปดาห์ และไม่เกิน 11 ปี</li>
                    </ol>
                  </li>
                  <li className='mt-3'>1 กรมธรรม์ สามารถลงทะเบียนรับความคุ้มครองสำหรับสัตว์เลี้ยงได้ไม่เกิน 2 ตัว</li>
                  <li className='mt-3'>เป็นเจ้าของและ/หรือ มีกรรมสิทธิ์หรือมีส่วน
    ได้เสียในสัตว์เลี้ยงที่นำขอรับความคุ้มครองจริง</li>
                  <li className='mt-3'>คำเตือนของสำนักงานคณะกรรมการกำกับ
    และส่งเสริมการประกอบธุรกิจประกันภัย (คปภ.) “การไม่เปิดเผยข้อความจริงหรือแถลงข้อความอันเป็นเท็จเป็นเหตุให้สัญญาประกันภัยเป็นโมฆียะ ตามประมวลกฎหมายแพ่งและพาณิชย์ 
    มาตรา 865”</li>
                  <li className='mt-3'>เงื่อนไขความคุ้มครองเป็นไปตามกรมธรรม์ประกันภัย โปรดศึกษารายละเอียดความคุ้มครอง เงื่อนไข ข้อยกเว้นได้ทาง เว็บไซต์ของบริษัทฯ</li>
                </ol>
              </div>
            </div>

          </div>
        </div>           

        </div>
        <FooterComponent></FooterComponent>
      </div>
  </div>
  )
}

export default MainPage;